import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MOCKUPS = [
    { id: 1, title: "L'Enseigne Boutique", img: "https://images.unsplash.com/photo-1542204165-65bf26472b9b?auto=format&fit=crop&w=800&q=80", type: "store" }, // Storefront
    { id: 2, title: "La Carte de Visite", img: "https://images.unsplash.com/photo-1596524430615-b46475ddff6e?auto=format&fit=crop&w=800&q=80", type: "card" }, // Business cards
    { id: 3, title: "L'Utilitaire Pro", img: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=800&q=80", type: "van" }, // White Van
];

export default function CommercialStudioPage() {
    const navigate = useNavigate();
    const [brand, setBrand] = useState('');
    const [generated, setGenerated] = useState(false);

    const handleGenerate = (e) => {
        e.preventDefault();
        setGenerated(true);
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#1e293b', color: 'white', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>

            {/* Header */}
            <div style={{ padding: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, display: 'flex', items: 'center', gap: 10 }}>🎩 Studio Branding</h1>
            </div>

            <div style={{ padding: 40, flex: 1, overflowY: 'auto' }}>

                {/* Input Area */}
                <form onSubmit={handleGenerate} style={{ maxWidth: 600, margin: '0 auto 50px auto', textAlign: 'center' }}>
                    <div style={{ marginBottom: 20 }}>Entrez le nom de la marque</div>
                    <input
                        autoFocus
                        type="text" placeholder="Ex: Boulangerie Paillard"
                        value={brand} onChange={e => setBrand(e.target.value)}
                        style={{
                            fontSize: '2rem', padding: '15px 30px', borderRadius: 50, border: 'none', textAlign: 'center', width: '100%',
                            background: 'rgba(255,255,255,0.1)', color: 'white', fontWeight: 800, outline: 'none'
                        }}
                    />
                </form>

                {/* Grid */}
                {brand && (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 40, maxWidth: 1200, margin: '0 auto' }}>
                        {MOCKUPS.map((mockup, idx) => (
                            <div key={mockup.id} className="animate-fade-up" style={{ animationDelay: `${idx * 0.2}s`, opacity: 0, animationFillMode: 'forwards' }}>
                                <div style={{ background: 'white', borderRadius: 16, overflow: 'hidden', height: 300, position: 'relative', boxShadow: '0 20px 50px -10px rgba(0,0,0,0.3)' }}>
                                    <img src={mockup.img} alt={mockup.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />

                                    {/* Overlay Logic - Fake Mockup Projection */}
                                    <div style={{
                                        position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        background: mockup.type === 'van' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.2)', mixBlendMode: 'multiply'
                                    }}>
                                        {/* This is the magic text projection */}
                                        <div style={{
                                            fontSize: mockup.type === 'card' ? '1.5rem' : '2.5rem',
                                            fontWeight: 900, color: mockup.type === 'card' ? '#1e293b' : 'white',
                                            textTransform: 'uppercase', letterSpacing: 2, textAlign: 'center',
                                            transform: mockup.type === 'van' ? 'perspective(500px) rotateY(-10deg) skewY(2deg)' :
                                                mockup.type === 'store' ? 'perspective(500px) rotateX(10deg)' : 'none',
                                            textShadow: mockup.type === 'store' ? '0 10px 20px rgba(0,0,0,0.5)' : 'none'
                                        }}>
                                            {brand}
                                        </div>
                                    </div>
                                </div>
                                <h3 style={{ textAlign: 'center', marginTop: 15, fontSize: '1.2rem', opacity: 0.7 }}>{mockup.title}</h3>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <button onClick={() => navigate('/commercial/launchpad')} style={{ margin: '0 auto 30px auto', background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer' }}>Retour</button>

            <style>{`.animate-fade-up { animation: fadeUp 0.8s ease-out; } @keyframes fadeUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }`}</style>
        </div>
    );
}
